import React from 'react';
import classNames from '../helpers/classNames.js';
const VersionFooter = ({
  children,
  hide
}) => {
  const footerClassNames = classNames('ebds-version-footer', {
    __hidden: !!hide
  });
  return /*#__PURE__*/React.createElement("div", {
    className: footerClassNames
  }, children);
};
export default VersionFooter;